<template>
    <div v-loading="loading" ref="opoo" :class="{ loading: !tableIndexTrue }">
        <template v-if="tableIndexTrue">
            <div class="outtitle" :style="{width: tableWidth}">
                <div class="headertitletwo" align="right"> {{ tableTitle[detailIndex].outname }}</div>
                <div class="headertitleone" align="center">{{ tableTitle[detailIndex].title }}</div>
                <div class="headertitlethree">
                    <!--<span class="leftspan" align="left">{{configName}}：{{ $store.state.divData.divname }}</span>-->
                    <span class="rightspan" align="right">单位:{{ tableTitle[detailIndex].company }}</span>
                </div>
            </div>
            <table border="0" cellspacing="0" :width="tableWidth">
                <thead>
                    <!--注释-->
                    <!-- 第一行**循环头部名称 如果没有子集就向下合并-->
                    <tr>
                        <!-- 头部包含2排 -->
                        <template v-if="tableHeader[detailIndex].numhead === 2">
                            <th v-for="(item,index) in tableHeader[detailIndex].header" :width="item.width"  :key="'a'+index" :rowspan="item.children.length? '':2" :colspan="item.children.length? item.children.length:''">{{ item.name }}</th>
                        </template>
                        <!-- 头部包含3排 -->
                        <template v-if="tableHeader[detailIndex].numhead === 3">
                            <th v-for="(item,index) in tableHeader[detailIndex].header"
                                :key="'a'+index"
                                :width="item.width" 
                                :rowspan="item.children.length? '':3"
                                :colspan="item.children.length? item.children.length + item.allkidsnum - item.allkidsparent:''">
                                {{ item.name }}
                            </th>
                        </template>
                        <!-- 头部包含4排 -->
                        <template v-if="tableHeader[detailIndex].numhead === 4">
                            <th v-for="(item,index) in tableHeader[detailIndex].header"
                                :key="'b'+index"
                                :width="item.width" 
                                :rowspan="item.children.length? '':4"
                                :colspan="item.children.length? item.children.length + item.allkidsnum - item.allkidsparent + item.allfourthsnum - item.allfourthparent:''">
                                {{ item.name }}
                            </th>
                        </template>
                    </tr>
                    <!-- 第二行** -->
                    <tr>
                        <!-- 含有2排 -->
                        <template v-if="tableHeader[detailIndex].numhead === 2">
                            <template v-for="(item,index) in tableHeader[detailIndex].header">
                                <!-- 循环完外层之后不做操作，然后再去循环内部children的个数，依次渲染出来  头部包含两排 -->
                                <th v-for="(m,i) in item.children" :width="m.width"  :key="index+'-'+i">{{ m.name }}</th>
                                <!-- template标签，里面如果渲染首次循环的值，children的值就无法渲染 -->
                            </template>
                        </template>
                        <!-- 含有3排 -->
                        <template v-if="tableHeader[detailIndex].numhead === 3">
                            <template v-for="(item,index) in tableHeader[detailIndex].header">
                                <th v-for="(seconditem,i) in item.children" :width="seconditem.width"  :key="index+'-'+i" :rowspan="seconditem.thrchilds.length ? '':2" :colspan="seconditem.thrchilds.length? seconditem.thrchilds.length:''">{{ seconditem.name }}</th>
                            </template>
                        </template>
                        <!-- 含有4排 -->
                        <template v-if="tableHeader[detailIndex].numhead === 4">
                            <template v-for="(item,index) in tableHeader[detailIndex].header">
                                <th v-for="(seconditem,i) in item.children" :width="seconditem.width" :key="index+'-'+i" :rowspan="seconditem.thrchilds.length ? '':3" :colspan="seconditem.thrchilds.length? seconditem.thrchilds.length + seconditem.nowfourthsnum - seconditem.nowfourthparent:''">{{ seconditem.name }}</th>
                            </template>
                        </template>

                    </tr>
                    <!-- 第三行** -->
                    <!--含有3排-->
                    <tr v-if="tableHeader[detailIndex].numhead === 3">
                        <!-- 首先循环最外层 将第一排的数据拿出来，然后循环第二排的数据，最后获取第三排的数据 -->
                        <template v-for="(item,index) in tableHeader[detailIndex].header">
                            <template v-for="(seconditem,secondindex) in item.children">
                                <th v-for="(thr,thrindex) in seconditem.thrchilds"  :width="thr.width" :key="index + '-' + secondindex + '-' +thrindex">{{ thr.name }}</th>
                            </template>
                        </template>
                    </tr>
                    <!-- 第三行** -->
                    <!--含有4排-->
                    <tr v-if="tableHeader[detailIndex].numhead === 4">
                        <!-- 首先循环最外层 将第一排的数据拿出来，然后循环第二排的数据，最后获取第三排的数据 -->
                        <template v-for="(item,index) in tableHeader[detailIndex].header">
                            <template v-for="(seconditem,secondindex) in item.children">
                                <th v-for="(thr,thrindex) in seconditem.thrchilds" :width="thr.width" :key="index + '-' + secondindex + '-' +thrindex" :rowspan="thr.fourchilds.length ? '':2" :colspan="thr.fourchilds.length? thr.fourchilds.length:''">{{ thr.name }}</th>
                            </template>
                        </template>
                    </tr>
                    <!--含有4排第四行-->
                    <tr v-if="tableHeader[detailIndex].numhead === 4">
                        <!-- 首先循环最外层 将第一排的数据拿出来，然后循环第二排的数据，最后获取第三排的数据 -->
                        <template v-for="(item,index) in tableHeader[detailIndex].header">
                            <template v-for="(seconditem,secondindex) in item.children">
                                <template v-for="(thr,thrindex) in seconditem.thrchilds" :key="index + '-' + secondindex + '-' +thrindex">
                                    <th v-for="(fourname,fourindex) in thr.fourchilds" :width="fourname.width" :key="index + '-' + secondindex + '-' +thrindex + '-'+ fourindex">
                                        {{ fourname.name }}
                                    </th>
                                </template>
                            </template>
                        </template>
                    </tr>
                    <!-- 如果有栏次这一行 -->
                    <tr>
                        <th v-for="(item,index) in tableHeader[detailIndex].columns"
                            :key="index"
                            :colspan="item.col">{{ item.name }}</th>
                    </tr>
                </thead>
                <tbody v-if="allbody" ref="thbody" class="thbody">
                    <template v-for="(item,index) in renderContent">
                        <tr v-if="index == 0">
                            <!--判断第一行的情况-->
                            <template v-for="(itemtwo,indextwo) in item">
                                <!--表7第一列不需要控制-->
                                <!--禹城单独控制表13-->
                                <template v-if="indextwo == 0">
                                    <template v-if="$store.state.divData.zone.indexOf('yucheng')>-1 && detailIndex == 12">
                                        <td :width="itemtwo.width" v-if="itemtwo.name !== '不显示'" :class="[itemtwo.type == 'number' ? 'showright' : '',itemtwo.class ? itemtwo.class : '']" :colspan="isNullTable ? '': tableDataConfig[detailIndex].emptytable.colspan" :style="compact(itemtwo.name)=='合计' ? 'text-align:center' : ''" :key="indextwo+'-'+index">
                                            {{itemtwo.name}}
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td :width="itemtwo.width" v-if="itemtwo.name !== '不显示'" :class="[itemtwo.type == 'number' ? 'showright' : '',itemtwo.class ? itemtwo.class : '']" :colspan="isNullTable ? '': tableDataConfig[detailIndex].emptytable.colspan" :style="compact(itemtwo.name)=='合计' ? 'text-align:center' : ''" :key="indextwo+'-'+index">
                                           {{itemtwo.name}}
                                        </td>
                                    </template>
                                </template>
                                <template v-if="indextwo !== 0">
                                    <td :width="itemtwo.width" v-if="itemtwo.name !== '不显示'" :class="[itemtwo.type == 'number' ? 'showright' : '',itemtwo.class ? itemtwo.class : '']" :key="indextwo+'-'+index">
                                        <template v-if="detailIndex == 6 && ismodify && !isPdf">
                                            <template v-if="indextwo == 2 || indextwo == 6 || indextwo == 8">{{itemtwo.name}}</template>
                                            <input v-else type="text" placeholder="" v-model="itemtwo.name" @change="search($event)" />
                                        </template>
                                        <template v-else>{{itemtwo.name}}</template>
                                    </td>
                                </template>
                            </template>
                        </tr>
                        <tr v-if="index !== 0">
                            <template v-for="(itemtwo,indextwo) in item">
                                <template v-if="$store.state.divData.zone.indexOf('yucheng')>-1 && detailIndex == 12 && indextwo == 0">
                                    <td :width="itemtwo.width" v-if="itemtwo.name !== '不显示'" :class="[itemtwo.type == 'number' ? 'showright' : '',itemtwo.class ? itemtwo.class: '']" :key="indextwo+'-'+index">
                                        {{itemtwo.name}}
                                    </td>
                                </template>
                                <template v-else>
                                    <td :width="itemtwo.width" v-if="itemtwo.name !== '不显示'" :class="[itemtwo.type == 'number' ? 'showright' : '',itemtwo.class ? itemtwo.class: '']" :key="indextwo+'-'+index">
                                        <template v-if="detailIndex == 6 && ismodify && !isPdf">
                                            <template v-if="indextwo == 0 || indextwo == 2 || indextwo == 6 || indextwo == 8">{{itemtwo.name}}</template>
                                            <input v-else type="text" placeholder="" v-model="itemtwo.name" @change="search($event)" />
                                        </template>
                                        <template v-else>{{itemtwo.name}}</template>
                                    </td>
                                </template>

                            </template>
                        </tr>
                    </template>
                    <!--注释为空时不显示那一行-->
                    <template v-if="remarkList[detailIndex][0].name != ''">
                        <tr>
                            <td class="notes" :colspan="tableHeader[detailIndex].allcolspan" :noteid="detailIndex+1">
                                <p :class="[item.left=='0'?'':'left16']" v-for="(item,index) in remarkList[detailIndex]">
                                    {{item.name}}
                                </p>
                            </td>
                        </tr>
                    </template>

                </tbody>
            </table>
        </template>
        <div v-if="detailIndex == 6 && ismodify && !isPdf ">
            <span v-if="isBinzhou" class="zero">数据为空要填写0值！</span>
            <el-button style="float:right;margin-top:10px;" @click="saveNumber" size="small" type="primary">保存</el-button>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import { modifyTable } from '@/api/div.js'
    import { getMutateTableProfile } from '@/api/zone.js'
    import { getDivList } from "@/api/index.js";
    import { Number } from 'core-js';
    export default {
        name: 'TableIndex',
        props: {
            tablenum: {
                type: Number,
                default: 0
            },
            pdfmoreDetails: {
                type: Object,
                default: () => { }
            },
            pdfdataJson: {
                type: Array,
                default: () => []
            },
            pdfsubjectCofig: {
                type: Array,
                default: () => []
            },
            pdfthreeLines: {
                type: Array,
                default: () => []
            },
        },
        data() {
            var zone = this.$store.state.divData.zone
            let isBinzhou = zone.indexOf('binzhou') > -1 || zone == 'bincheng' || zone == 'zhanhua' ? true : false
            return {
                tableWidth: '100%',
                configName: '',
                tableConfig: {},//表格配置
                //表格标题
                tableTitle: [],
                //表头数据
                tableHeader: [],
                //主体数据
                tableData: [],

                tableDataConfig: [],//主体数据配置
                // 当前要查看的文件的下标
                detailIndex: 0,
                // 头部需要合并的单元格个数
                testColspan: 1,
                // 合计一栏需要合并的个数
                toallMerge: 1,
                thh: true,
                //计算后的个数
                renderContent: [],//渲染后的内容
                allbody: false,
                colspand: false,
                colspanb: false,
                tableIndexTrue: false,
                loading: false,
                isPdf: this.$parent.isPdf,
                dataIndex: '',
                remarkList: [],
                isNullTable: false,
                nullTips: '',
                ismodify: false,//是否可以修改三公表
                allrows: [],
                isBinzhou: isBinzhou
            }
        },
        watch: {
            detailIndex: {
                handler() {
                    this.getDivList()
                    this.judge() //在监听是否可以修改表格里放上判断表7是否为空
                }
            }
        },

        async mounted() {
            this.configName = this.$store.state.divData.type == 0 ? '单位' : '部门'
            await this.TableProfile()
            await this.zaozhuangEdit()
            await this.getDivList()
            await this.judge()
        },

        updated() {
            this.NoRefresh()
        },
        methods: {
            //枣庄21ys单独控制
            zaozhuangEdit() {
                if (this.$store.state.divData.zone == 'zaozhuang' && this.$store.state.openYear == '2021') {
                    let xiangindex = this.tableHeader[12].header.findIndex(item => item.name == '项目类型')
                    if (xiangindex > 0) {
                        this.tableHeader[12].header.splice(1, 1)
                        this.tableHeader[12].allcolspan = 11
                    }
                    this.tableHeader[6].header[0].name = '2020年预算数'
                    this.tableHeader[6].header[1].name = '2021年预算数'
                }
            },
            //判断是否可以修改三公表
            async judge() {
                if (!this.$parent.isPdf) { this.$store.commit('resetErrors', '') }//清空提示的数据
                if (this.detailIndex == 6) {
                    let ismodify = await getMutateTableProfile()
                    if (ismodify.status == 0) {
                        this.ismodify = ismodify.enabled
                    }
                }
            },
            //保存三公表的数据
            async saveNumber() {
                let that = this
                if (this.allrows.length > 0) {
                    if (this.allrows[0].b == '' || this.allrows[0].d == '' || this.allrows[0].e == '' || this.allrows[0].f == '' || this.allrows[0].h == '' || this.allrows[0].j == '' || this.allrows[0].k == '' || this.allrows[0].l == '') {
                        if (this.isBinzhou) {
                            that.$message.error("数据为空要填写0值！一般公共预算“三公”经费支出预算表中除‘合计’和‘小计’外，其余为必填！")
                        } else {
                            that.$message.error("一般公共预算“三公”经费支出预算表中除‘合计’和‘小计’外，其余为必填！");
                        }
                    } else {
                        this.loading = true
                        let data = {
                            id: this.$route.query.divid,
                            tableName: '7',
                            rows: this.allrows
                        }
                        let res = await modifyTable(data)
                        if (res.status == 0) {
                            this.$message.success("保存成功")
                            this.allrows = []
                            //重新获取表格数据
                            let resid = await getDivList({ id: this.$route.query.divid })
                            this.$store.commit("changeDivData", resid);
                            this.$store.commit(
                                "changeTableData",
                                resid.tables.filter((item) => item.year == this.$store.state.openYear && item.type == this.$store.state.openType)
                            );
                            that.loading = false
                        } else {
                            this.$message.error(res);
                        }
                    }

                } else {
                    this.$message.error("请先修改数据！");
                }
            },
            async search(e) {
                let that = this
                let rows = []
                //三公表修改数据
                if (this.detailIndex == 6) {
                    for (let i = 0; i < this.renderContent.length; i++) {
                        let pushrows = {}
                        //计算合计和小计
                        for (let j = 0; j < this.renderContent[i].length; j++) {
                            var culnum = this.renderContent[i]
                            culnum[2].name = that.numFormat(that.tableNum((this.thousand(culnum[3].name) + this.thousand(culnum[4].name)).toString()))
                            culnum[0].name = that.numFormat(that.tableNum((this.thousand(culnum[1].name) + this.thousand(culnum[2].name) + this.thousand(culnum[5].name)).toString()))

                            culnum[8].name = that.numFormat(that.tableNum((this.thousand(culnum[9].name) + this.thousand(culnum[10].name)).toString()))
                            culnum[6].name = that.numFormat(that.tableNum((this.thousand(culnum[7].name) + this.thousand(culnum[8].name) + this.thousand(culnum[11].name)).toString()))

                            culnum[j].name = that.numFormat(that.tableNum(culnum[j].name))
                            pushrows[this.filterLetters(j)] = this.renderContent[i][j].name
                        }
                        rows.push(pushrows)
                    }
                }
                this.allrows = rows
            },
            //根据下标转换成26个字母
            filterLetters(i) {
                if (i >= 0 && i <= 25) {
                    return String.fromCharCode(65 + i).toLowerCase();
                } else {
                    return undefined;
                }
            },
            //更换表格下标
            NoRefresh() {
                const that = this
                if (this.$parent.isPdf) {
                    that.detailIndex = that.tablenum
                } else {
                    that.detailIndex = Number(this.$route.params.id) - 1
                }
            },
            //获取表格配置头部、前三行cj
            TableProfile() {
                const that = this
                if (!this.$parent.isPdf) {
                    this.tableConfig = this.$store.state.tableConfig
                    if (this.$store.state.divData.type == 0) {
                        this.tableTitle = this.tableConfig.threeLines.forEach(function (item, index) {
                            item.outname = item.outname.replace(/部门/g, '单位')
                        })
                    } else {
                        this.tableTitle = this.tableConfig.threeLines
                    }
                    this.tableHeader = this.tableConfig.dataJson
                    this.tableDataConfig = this.tableConfig.subjectCofig
                    //用途1？
                    this.$store.commit("storageHop", this.tableConfig)
                    //备注
                } else {
                    if (this.$store.state.divData.type == 0) {
                        this.tableTitle = this.pdfthreeLines.forEach(function (item, index) {
                            item.outname = item.outname.replace(/部门/g, '单位')
                        })
                    } else {
                        this.tableTitle = this.pdfthreeLines
                    }
                    this.tableHeader = this.pdfdataJson
                    this.tableDataConfig = this.pdfsubjectCofig
                }
            },

            /**
            * 获取数据
            */
            async getDivList() {
                $('.content').scrollTop(0)
                $('.content').scrollLeft(0)
                //初始化空表状态
                this.isNullTable = false
                const that = this
                if (this.$parent.isPdf) {
                    this.loading = true
                    let res = this.pdfmoreDetails
                    //获取2022年数据
                    const allTables = res.tables.filter((item) => item.year == this.$store.state.openYear && item.type == "ys")
                    this.tableData = allTables
                } else {
                    this.loading = true
                    this.tableData = this.$store.state.tableData
                }
                //山东预算会出现空表的问题，原因是9.10.11三个表为空，后台没有返回，此处统一处理空表问题
                for (var i = 1; i < 14; i++) {
                    if (this.tableData.filter(item => item.name == i).length == 0) {
                        let pusnempty = { name: i.toString(), year: this.$store.state.openYear, type: 'ys', rows: [{ a: "" }] }
                        this.tableData.splice(i - 1, 0, pusnempty)
                    }
                }
                this.$store.commit("changeTableData", this.tableData)
                //获取到数据之后显示表格
                this.tableIndexTrue = true
                await this.renderData()
                this.loading = false
            },
            //渲染数据
            renderData() {
                let that = this
                let list = []
                let showColumus = []//要显示的列
                let typeColumus = [] //数字类型的列
                let thisConfig = '' //表格主体数据配置
                let tableContent = '' //表格主体数据
                let headertable = ''//头部配置
                let emalert = ''//头部表几
                //tableContent = this.tableData[this.detailIndex].rows //当前表格主体数据
                tableContent = this.tableData.find(e => e.name == Number(that.detailIndex) + 1).rows //当前表格主体数据
                if (this.tableDataConfig) {
                    //当前配置
                    thisConfig = this.tableDataConfig[that.detailIndex]
                    this.tableTitle = this.$store.state.hop.threeLines
                    emalert = this.$store.state.hop.threeLines
                } else {
                    thisConfig = that.tableDataConfig[that.detailIndex] //表格主体数据
                }
                if (this.tableDataConfig) {
                    //枣庄单独控制
                    if (this.detailIndex == 12 && this.$store.state.divData.zone == 'zaozhuang' && this.$store.state.openYear == '2021') {
                        headertable = Number(11)
                    } else {
                        headertable = this.tableHeader[that.detailIndex].allcolspan
                    }
                }

                let newpanduan = thisConfig.newshowtime
                //判断第一列的值,如果需要继续合并d列,就走下面的方法
                if (thisConfig.firstline.indexOf('d') > -1) {
                    delete tableContent[0].d
                    that.colspand = true
                } else {
                    that.colspand = false
                }
                //判断第一列的值,如果需要继续合并b列,就走下面的方法
                if (thisConfig.firstline.indexOf('b') > -1) {
                    delete tableContent[0].b
                    that.colspanb = true
                } else {
                    that.colspanb = false
                }
                //获取需要渲染的列，以及类型
                for (var h = 0; h < newpanduan.length; h++) {
                    showColumus.push(newpanduan[h].name)
                    if (newpanduan[h].type == 'number') {
                        typeColumus.push(newpanduan[h].name)
                    }
                }
                typeColumus = typeColumus.toString() //数字类型的列
                showColumus = showColumus.toString().replace(/,/g, "") //要显示的列
                this.nullTips = emalert[that.detailIndex].title.replace("表", "").replace("总", "")
                //判断是否是空表空表判断
                if (thisConfig.emptytable.value != 0) {
                    if (that.detailIndex == 0 || that.detailIndex == 3) {
                        let value = thisConfig.emptytable.value.split("")
                        var nullIndex = 0;
                        for (var a of value) {
                            if (this.num(tableContent[tableContent.length - 1][a]) > 0) {
                                nullIndex++
                            }
                        }
                        this.isNullTable = nullIndex > 0 ? false : true
                    } else {
                        let value = ''
                        if (this.detailIndex == 12 && this.$store.state.divData.zone == 'zaozhuang' && this.$store.state.openYear == '2021') {
                            value = ['b']
                        } else {
                            value = thisConfig.emptytable.value.split("")

                        }
                        var nullIndex = 0;
                        for (var a of value) {
                            if (this.num(tableContent[0][a]) > 0) {
                                nullIndex++
                            }
                        }
                        this.isNullTable = nullIndex > 0 ? false : true
                    }
                }
                //注释/备注******************************start 挪了位置
                let remarkList = []
                let newcompany = that.$store.state.divData.divname
                for (let i = 0; i < this.tableHeader.length; i++) {
                    //如果不是空表
                    if (!this.isNullTable) {
                        //******
                        if (that.detailIndex == 6 && this.$store.state.divData.qksm['表7剔除'] == '是') {
                            remarkList.push([{ name: '注：已按要求剔除科研人员因公临时出国经费。', left: '0' }])
                        } else if (that.detailIndex == 12 && this.$store.state.divData.qksm['表13剔除'] == '是') {
                            remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分项目公开时予以剔除。', left: '0' }])
                        } else if (that.detailIndex == 1 && this.$store.state.divData.qksm['表13剔除'] == '是') {
                            remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                        } else if (that.detailIndex == 2 && this.$store.state.divData.qksm['表13剔除'] == '是') {
                            remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                        } else if (that.detailIndex == 4 && this.$store.state.divData.qksm['表5剔除'] == '是') {
                            remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                        } else if (that.detailIndex == 7 && this.$store.state.divData.qksm['表8剔除'] == '是') {
                            remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                        } else if (that.detailIndex == 10 && this.$store.state.divData.qksm['表11剔除'] == '是') {
                            remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                        } else if (this.tableHeader[i].note.notEmpty.indexOf('2') > -1) {
                            let emptymesg = this.tableHeader[i].note.notEmpty
                            let indexbiao = Number(this.tableHeader[i].note.notEmpty.indexOf('2'))
                            remarkList.push([{ name: '注：' + emptymesg.slice(0, indexbiao), left: '0' }, { name: emptymesg.slice(indexbiao), left: '16px' }])
                        } else if (this.tableHeader[i].note.notEmpty == '') {
                            remarkList.push([{ name: '', left: '0' }])
                        } else {
                            remarkList.push([{ name: '注：' + this.tableHeader[i].note.notEmpty, left: '0' }])
                        }
                    } else {
                        if (that.detailIndex == 0) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无收支预算。', left: '0' }])
                        } else if (that.detailIndex == 1) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无收入预算。', left: '0' }])
                        } else if (that.detailIndex == 2) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无支出预算。', left: '0' }])
                        } else if (that.detailIndex == 3) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无财政拨款收支预算。', left: '0' }])
                        } else if (that.detailIndex == 4) {
                            if (this.$store.state.divData.qksm['表5剔除'] == '是') {
                                remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                            } else {
                                remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年没有使用一般公共预算拨款安排的支出。', left: '0' }])
                            }
                        } else if (that.detailIndex == 5) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年没有使用一般公共预算拨款安排的支出。', left: '0' }])
                        } else if (that.detailIndex == 6) {
                            if (this.$store.state.divData.qksm['表7剔除'] == '是') {
                                remarkList.push([{ name: '注：已按要求剔除科研人员因公临时出国经费。', left: '0' }])
                            } else {
                                if (that.$store.state.divData.zone == 'zaozhuang' && that.$store.state.openYear == '2021') {
                                    remarkList.push([{ name: '注：' + newcompany + '2020年、2021年均未使用一般公共预算拨款安排“三公”经费支出。', left: '0' }])
                                } else {
                                    remarkList.push([{ name: '注：' + newcompany + '2021年、2022年均未使用一般公共预算拨款安排“三公”经费支出。', left: '0' }])
                                }
                            }
                        } else if (that.detailIndex == 7) {
                            if (this.$store.state.divData.qksm['表8剔除'] == '是') {
                                remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                            } else {
                                remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年没有使用政府性基金预算拨款安排的支出。', left: '0' }])
                            }
                        } else if (that.detailIndex == 8) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年没有使用政府性基金预算拨款安排的基本支出。', left: '0' }])
                        } else if (that.detailIndex == 9) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年没有使用国有资本经营预算拨款安排的支出。', left: '0' }])
                        } else if (that.detailIndex == 10) {
                            if (this.$store.state.divData.qksm['表11剔除'] == '是') {
                                remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分科目公开时予以剔除。', left: '0' }])
                            } else {
                                remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无政府采购预算支出。', left: '0' }])
                            }
                        } else if (that.detailIndex == 11) {
                            remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无基本支出预算。', left: '0' }])
                        } else if (that.detailIndex == 12) {
                            if (this.$store.state.divData.qksm['表13剔除'] == '是') {
                                remarkList.push([{ name: '注：根据国家保密法律法规和有关保密事项范围的规定，部分项目公开时予以剔除。', left: '0' }])
                            } else {
                                remarkList.push([{ name: '注：' + newcompany + this.$store.state.openYear + '年无项目支出预算。', left: '0' }])
                            }
                        }
                    }

                }
                let configName = this.$store.state.divData.type == 0 ? '单位' : '部门'
                if (configName == '单位') {
                    remarkList.forEach(function (item, index) {
                        item.forEach(function (itemtwo, indextwo) {
                            itemtwo.name = itemtwo.name.replace(/部门/gi, '单位')
                        })
                    })
                    this.remarkList = remarkList
                } else {
                    this.remarkList = remarkList
                }
                //注释******************************end


                //空表补全---判断是否是空表，空表加两行空行，并补全第一行，表1表4表7为固定格式，不补全表格
                //console.log('headertable[that.detailIndex].allcolspan', headertable[that.detailIndex].allcolspan)
                if (this.isNullTable && that.detailIndex != 0 && that.detailIndex != 6 && that.detailIndex != 3) {
                    if (thisConfig.emptytable.isNullLine == 3) {
                        let columns = []
                        for (let i = 0; i < 3; i++) {
                            let emptyTr = []
                            if (i == 0) {
                                //判断第一行，如果合计单元格为1则补全正常长度，否则减少colspans格 ，如果不是1则用总宽度减去首个表格合并的个数(colspan)
                                if (thisConfig.emptytable.colspan > 0) {
                                    //如果空表的合计也要合并，那么上面渲染部分代码需要更改，此处减去colspan
                                    for (let j = 0; j < headertable; j++) {
                                        //表1-3不会为空，表4和表7为固定表，所以从表5-13开始判断，有数字的地方才加0.00，其余为空
                                        //判断第一行中的某个
                                        if (that.detailIndex == 1) {
                                            if (j > 3) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            }
                                        } else if (that.detailIndex == 2) {
                                            if (j > 3) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '10%' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '10%' })
                                            }
                                        } else if (that.detailIndex == 4) {
                                            that.tableWidth = '100%'
                                            if (j == 3) {
                                                emptyTr.push({ 'name': '', 'type': 'text', 'width': '11%' })
                                            } else if (j > 3) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '11%' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '11%' })
                                            }
                                        } else if (that.detailIndex == 5) {
                                            that.tableWidth = '100%'
                                            if (j == 2) {
                                                emptyTr.push({ 'name': '', 'type': 'text', 'width': '11%' })
                                            } else if (j > 5) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '11%' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '11%' })
                                            }
                                        } else if (that.detailIndex == 7) {
                                            that.tableWidth = '100%'
                                            if (j == 3) {
                                                emptyTr.push({ 'name': '', 'type': 'text', 'width': 'auto' })
                                            } else if (j > 3) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            }
                                        } else if (that.detailIndex == 8) {
                                            if (j > 5) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            }
                                        } else if (that.detailIndex == 9) {
                                            if (j > 3) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            }
                                        } else if (that.detailIndex == 10) {
                                            if (j > 3) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            }
                                        } else if (that.detailIndex == 11) {
                                            that.tableWidth = '100%'
                                            if (j > 2) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': 'auto' })
                                            }
                                        } else if (that.detailIndex == 12) {
                                            that.tableWidth = '100%'
                                            if (j == 0) {
                                                emptyTr.push({ 'name': '', 'type': 'text', 'width': '7%' })
                                            } else if (j > 1) {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '7%' })
                                            } else {
                                                emptyTr.push({ 'name': '', 'type': 'number', 'width': '7%' })
                                            }
                                        }

                                    }
                                }

                            } else {
                                for (let j = 0; j < headertable; j++) {
                                    emptyTr.push({ 'name': '' })
                                }
                            }
                            columns.push(emptyTr)
                        }
                        this.renderContent = columns
                        return
                    }
                }
                //根据配置去定义表格的数据类型以及列宽度（表格总数据）
                for (var i = 0; i < tableContent.length; i++) {
                    let array = []
                    for (let key in tableContent[i]) {
                        let obj = tableContent[i][key]
                        let newobj = new Object();
                        //如果要显示的列里包含返回的列就追加进数组
                        if (showColumus.indexOf(key) > -1) {
                            //console.log('包含的下标', key, showColumus.indexOf(key), showColumus, newpanduan[showColumus.indexOf(key)].width)
                            //如果数字类型的组里包含返回的列就添加type
                            if (typeColumus.indexOf(key) == -1) {
                                newobj.name = obj
                                newobj.type = 'text'
                            } else {
                                newobj.name = obj
                                newobj.type = 'number'
                            }
                            newobj.width = newpanduan[showColumus.indexOf(key)].width
                            newobj.col = 1
                            array.push(newobj)
                        }
                    }
                    list.push(array)
                }
                //根据数据长度控制表格宽度
                if (!this.$parent.isPdf) {
                    if (that.detailIndex == 1) {
                        that.tableWidth = '140%'
                    } else if (that.detailIndex == 8 || that.detailIndex == 9) {
                        //that.tableWidth = '150%'
                    } else if (that.detailIndex == 10) {
                        that.tableWidth = '130%'
                    } else {
                        that.tableWidth = '100%'
                    }
                }
                //合计合并，山东预算表格和决算不一样，第一行合计的合并个数有点儿多，但是合计在第几个表格不用担心，因为如果abc是空的，删除完abc之后，合计会变成第一个
                let newdelColspan = this.tableDataConfig[that.detailIndex].emptytable.colspan
                if (newdelColspan > 1) {
                    list[0].splice(0, Number(newdelColspan) - 1)
                    //表6单独控制，合并个数太多，手动添加name合计
                    if (that.detailIndex == 5 || that.detailIndex == 8) {
                        list[0][0].name = '合计'
                        list[0][0].class = 'textauto'
                    } else if (that.detailIndex == 1 || that.detailIndex == 2 || that.detailIndex == 4 || that.detailIndex == 7 || that.detailIndex == 11) {
                        list[0][0].name = ''
                        list[0][0].name = '合计'
                        list[0][0].class = 'textauto'
                    }
                }
                //正常表格补全表格补全空表格,
                if (that.detailIndex >= 0) {
                    let that = this
                    let firstlength = headertable
                    let helpWidth = 'auto'
                    //if (that.detailIndex == 0) {
                    //    helpWidth = 'auto'
                    //} else if (that.detailIndex == 1) {
                    //    helpWidth = 'auto'
                    //} else if (that.detailIndex == 2) {
                    //    helpWidth = '5%'
                    //} else if (that.detailIndex == 3 || that.detailIndex == 7) {
                    //    helpWidth = '10%'
                    //} else if (that.detailIndex == 4) {
                    //    helpWidth = '12%'
                    //} else if (that.detailIndex == 6) {
                    //    helpWidth = '8%'
                    //} else if (that.detailIndex == 8 || that.detailIndex == 9) {
                    //    helpWidth = '10%'
                    //} else if (that.detailIndex == 10 || that.detailIndex == 11) {
                    //    helpWidth = '6%'
                    //} else if (that.detailIndex == 5) {
                    //    helpWidth = '14%'
                    //} else if (that.detailIndex == 12) {
                    //    helpWidth = '7%'
                    //}
                    list.forEach(function (item, index) {
                        //根据colspan去判断补全的个数  colspan大于1要重新判断
                        if (index == 0) {
                            let allres = headertable - (thisConfig.emptytable.colspan - 1) - item.length
                            if (allres > 0) {
                                //第一行时配置
                                for (let a = 0; a < allres; a++) {
                                    list[index].push({ 'name': '', 'width': helpWidth, 'type': 'number' })
                                }
                            }
                        } else {
                            if (list[index].length < firstlength) {
                                let chalength = Number(firstlength - list[index].length)//每行要补全的表格数
                                for (let j = 0; j < chalength; j++) {
                                    list[index].push({ 'name': '', 'width': helpWidth, 'type': 'number' })
                                }
                            }
                        }
                    })
                }
                //新增缩进功能
                list.forEach(function (item, index) {
                    if (index != 0) {
                        if (that.detailIndex == 1 || that.detailIndex == 2 || that.detailIndex == 4 || that.detailIndex == 7 || that.detailIndex == 9 || that.detailIndex == 10) {
                            if ((that.compact(item[0].name) != '' && that.compact(item[1].name) != '' && that.compact(item[2].name) == '')) {
                                item[3].class = 'textindent1'
                            } else if (that.compact(item[0].name) != '' && that.compact(item[1].name) != '' && that.compact(item[2].name) != '') {
                                item[3].class = 'textindent2'
                            }
                        } else if (that.detailIndex == 5 || that.detailIndex == 8) {
                            if ((that.compact(item[0].name) != '' && that.compact(item[1].name) != '')) {
                                item[2].class = 'textindent1'
                            } else if ((that.compact(item[3].name) != '' && that.compact(item[4].name) != '')) {
                                item[5].class = 'textindent1'
                            }
                        } else if (that.detailIndex == 11) {
                            if ((that.compact(item[0].name) != '' && that.compact(item[1].name) != '')) {
                                item[2].class = 'textindent1'
                            }
                        }
                    }
                })
                //新增需求，根据科目判断后面的单约个是否为空，为空改为0.00 ,山东保留两位小数  表格配置好再调整
                let twonum = ''
                if (thisConfig.fixedNum > 0) {
                    twonum = true
                }
                //根据不同表的列保留两位小数,并添加千分符
                //因为第一行合计合并了很多个数，所以第一行单独处理66666666
                list.forEach(function (item, index) {
                    item.forEach(function (itemtwo, indextwo) {
                        if (that.$store.state.divData.zone == 'zaozhuang' && that.$store.state.openYear == '2021') {
                            if (Number(itemtwo.name) == 0) {
                                itemtwo.name = ''
                            }
                        }
                        if (that.detailIndex == 0) {
                            if (indextwo == 1 || indextwo == 3) {
                                let res = that.numFormat(that.tableNum(itemtwo.name))
                                itemtwo.name = res
                            }
                        } else if (that.detailIndex == 3) {
                            if (indextwo == 1 || indextwo > 2) {
                                let res = that.numFormat(that.tableNum(itemtwo.name))
                                itemtwo.name = res
                            }
                        } else if (that.detailIndex == 5 || that.detailIndex == 8) {
                            if (index == 0) {
                                if (indextwo > 0) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            } else {
                                if (indextwo > 5) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            }

                        } else if (that.detailIndex == 6) {
                            if (indextwo >= 0) {
                                let res = that.numFormat(that.tableNum(itemtwo.name))
                                itemtwo.name = res
                            }
                        } else if (that.detailIndex == 9) {
                            if (indextwo > 4) {
                                let res = that.numFormat(that.tableNum(itemtwo.name))
                                itemtwo.name = res
                            }
                        } else if (that.detailIndex == 12) {
                            if (that.$store.state.divData.zone == 'zaozhuang' && that.$store.state.openYear == '2021') {
                                if (indextwo > 0) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            } else {
                                if (indextwo > 1) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            }

                        } else if (that.detailIndex == 11) {
                            if (index == 0) {
                                if (indextwo > 0) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            } else {
                                if (indextwo > 2) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            }

                        } else {
                            //表1.2.4.7.9.10格式一样
                            if (index == 0) {
                                if (indextwo > 0) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            } else {
                                if (indextwo > 3) {
                                    let res = that.numFormat(that.tableNum(itemtwo.name))
                                    itemtwo.name = res
                                }
                            }

                        }




                    })
                })
                //山东表如果内容为0则另其为0.00; if(twonum)这个判断可以不写，因为表格都是会保留两位小数
                if (twonum) {
                    list.forEach(function (item, index) {
                        item.forEach(function (itemtwo, indextwo) {
                            //空表表格为0或者表7表格数值为空时，另其变为0.00
                            if (itemtwo.name == '0') {
                                itemtwo.name = '0.00'
                                itemtwo.class = 'showright'
                            } else if (that.detailIndex == 6 && itemtwo.name == '' && !that.isBinzhou) {
                                itemtwo.name = '0.00'
                                itemtwo.class = 'showright'
                            } else if (that.detailIndex == 12 && indextwo == 1 && that.$store.state.divData.zone == 'zaozhuang' && that.$store.state.openYear == '2021') {
                                itemtwo.class = 'showright'
                            }
                            //单独控制部分表格居中并修改内容
                            if (that.detailIndex == 0 && that.$store.state.divData.zone != 'laiwu') {
                                if (itemtwo.name.includes('事业收入')) {
                                    itemtwo.name = itemtwo.name + '（不含教育收费）'
                                } else if (itemtwo.name.toString().includes('本年收入合计') || itemtwo.name.toString().includes('本年支出合计') || itemtwo.name.toString().replace(/\ +/g, "").includes('收入总计') || itemtwo.name.toString().replace(/\ +/g, "").includes('支出总计')) {
                                    itemtwo.class = 'textauto'
                                }
                            } else if (that.detailIndex == 3) {
                                if (itemtwo.name.toString().includes('一、一般公共预算') || itemtwo.name.toString().includes('二、政府性基金预算') || itemtwo.name.toString().includes('三、国有资本经营预算')) {
                                    itemtwo.name = itemtwo.name + '拨款收入'
                                } else if (itemtwo.name.toString().includes('本年收入合计') || itemtwo.name.toString().includes('本年支出合计') || itemtwo.name.toString().replace(/\ +/g, "").includes('收入总计') || itemtwo.name.toString().replace(/\ +/g, "").includes('支出总计')) {
                                    itemtwo.class = 'textauto'
                                }
                            }
                        })

                    })
                }
                //给主体表赋值（渲染表格数据）
                if (thisConfig.delendline > 0) {
                    that.renderContent = list.slice(0, -thisConfig.delendline)
                } else {
                    that.renderContent = list
                }
                that.allbody = true

            },
            //去除千分位
            moneyDelete(num) {
                if (num && num != undefined && num != null) {
                    let _num = num;
                    _num = _num.toString();
                    _num = _num.replace(/,/gi, '');
                    return _num
                } else {
                    return num
                }
            },
        }
    }
</script>
<style scoped>
    .textindent1 {
        text-indent: 1em;
    }

    .textindent2 {
        text-indent: 2em;
    }
    .zero {
        color: red;
        font-size: 15px;
        font-family: FangSong;
    }

    tr td input {
        display: block;
        width: 100%;
        height: 100%;
        border: none;
        box-sizing: border-box;
        font-size: 15px;
        font: inherit;
        text-align: right;
    }

        tr td input[type=number]::-webkit-inner-spin-button,
        tr td input[type=number]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    /*** 消除input元素 type="number" 时默认的 加减按钮---moz版*/
    input[type=number] {
        -moz-appearance: textfield;
    }

    tr td input:focus {
        border: 1px solid #efefef;
        outline: none;
    }

    .notes {
        border: none;
        box-sizing: border-box;
        padding-top: 10px;
    }

        .notes p {
            margin-bottom: 5px;
        }

    .textautoim {
        text-align: center !important;
    }

    pre {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
    }

    .left19 {
        padding-left: 1.9rem;
    }

    .left16 {
        padding-left: 1.9rem;
    }

    .tableBordernone {
        border: none;
        text-align: right;
    }

    .textauto {
        text-align: center;
    }

    .textaubold {
        text-align: center !important;
        font-weight: bold;
    }

    .noshow {
        display: none;
    }

    .noborder {
        border: none;
        text-align: left !important;
    }

    .showright {
        text-align: right;
    }

    .autocenter {
        text-align: center !important;
    }

    .headerTitle {
        font-size: 24px;
        background: white;
        border-color: white;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .headertitleone {
        font-size: 24px;
        background: white;
        border-color: white;
        padding: 5px 0;
        text-align: center;
        box-sizing: border-box;
        font-weight: bold;
        font-family: FangSong;
    }

    .headertitletwo {
        font-size: 15px;
        height: 36px;
        line-height: 36px;
        font-family: FangSong;
        text-align: right;
    }

    .headertitlethree {
        font-size: 15px;
        height: 36px;
        line-height: 36px;
        font-family: FangSong;
    }

    .outtitle {
        /*width: 100%;*/
        height: auto;
    }

    .tableTips {
        font-size: 15px;
        padding: 5px 0;
    }

    table {
        border-collapse: collapse;
        /*width: 100%;*/
        font-family: FangSong;
    }

        table th {
            font-weight: initial;
            height: 33px;
            background-color: #efefef;
            vertical-align: middle;
            border: 1px solid #808080;
        }

        table tr td {
            font-size: 15px;
            height: 33px;
            border: 1px solid #808080;
        }

    .department {
        border-color: white;
        border-bottom-color: #808080;
    }

        .department .leftspan {
            float: left;
        }

    .rightspan {
        float: right;
    }

    .loading {
        height: 500px;
    }
</style>

